export default __webpack_public_path__ + "static/media/Nvidia_(logo).svg.508cc41c.png";